import React from 'react'
import ReactDOM from 'react-dom'
import { App } from '@ExcelFilterRules/App'

export let startAddInFilterRules = props => {
  ReactDOM.render(
    <App excel_rules_data={props} />,
    document.getElementById('app')
  )
}
